import React from 'react';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FigmaBadge from '../Elements/FigmaBadge';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import JsxHelper from '../Helpers/JsxHelper';

export default class AddressItem {
  constructor(item) {
    if (item === undefined) {
      this.AddressId = '';
      this.Name = '';
      this.Line1 = '';
      this.City = '';
      this.State = '';
      this.CountryId = '';
      this.PostalCode = '';
      this.IsActive = true;
      this.Comments = '';
      this.CountryName = '';
      this.TypeText = '';
      this.TypeCode = '';
      return;
    }
    this.initialize(item);
  }

  async initialize(item) {
    this.AddressId = item.addressId;
    this.Name = item.name;
    this.Line1 = item.line1;
    this.City = item.city;
    this.State = item.state;
    this.CountryId = item.countryId;
    this.PostalCode = item.postalCode;
    this.IsActive = item.isActive;
    this.Comments = item.comments;
    this.CountryName = item.countryName;
    this.TypeText = item.typeText;
    this.EntityTypeId = item.entityTypeId;
    this.EntityId = item.entityId;
    this.TypeCode = '';
  }

  static NameOfTheIdField() {
    return 'AddressId';
  }
  static nameOfTheItemDetailList() {
    return 'Address';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOn', 'ModifiedOn'];

  static BoolFields = ['IsActive'];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'Name', label: 'Address Name' },
        { name: 'State', label: 'State' },
        { name: (item) => JsxHelper.YesNo(item.IsActive), label: 'Status' },
        { name: 'Line1', label: 'Street' },
        { name: 'PostalCode', label: 'Postal Code' },
        { name: 'TypeText', label: 'Type' },
        { name: 'City', label: 'City' },
        { name: 'CountryName', label: 'Country' },
        { name: '-', label: '' },
        { name: 'Comments', label: 'Comments', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'AddressId',
        orderById: 'Name',
        data: 'AddressId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 50,
      },
      { label: 'Address Name', orderById: 'Name', data: 'Name', minWidth: 50 },
      { label: 'Type', orderById: 'LeadId', data: 'TypeText', minWidth: 50 },
      { label: 'City', orderById: 'StatusCode', data: 'City', minWidth: 50 },
      { label: 'State', orderById: 'IsActive', data: 'State', minWidth: 50 },
      { label: 'Country', orderById: 'CountryName', data: 'CountryName', type: FieldTypesEnum.Email, minWidth: 50 },
      { label: 'Active?', orderById: 'OfficeId', data: (item) => AddressItem.getBadge(item.IsActive), minWidth: 50 },
      { label: ' ', orderById: 'EvFraudGroup', data: AddressItem.getActionsContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => AddressItem.editFunction(item.AddressId, item),
            roleKey: 'AddressAdmin_CreateAddress',
          },
        ]}
      />
    );
  }

  static getBadge(item) {
    return item ? (
      <div>
        <FigmaBadge active={true} />
      </div>
    ) : (
      <div>
        <FigmaBadge active={false} />
      </div>
    );
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };
}
